import { render, staticRenderFns } from "./surveillanceLeads.vue?vue&type=template&id=d5254424&"
import script from "./surveillanceLeads.vue?vue&type=script&lang=js&"
export * from "./surveillanceLeads.vue?vue&type=script&lang=js&"
import style0 from "./surveillanceLeads.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports